import * as React from "react";
import {moduleContent} from "./moduleContent";
import {HubFramework} from "../../HubFramework";
import {HubPathRouting} from "../../HubFramework/pathBuilder";
import {useMemo} from "react";
import {HubDataContext} from "./hubDataContext";

const Module: React.FC = () => {
    HubPathRouting.clearProjectAndModule()
    const moduleContext = useMemo(() => ({}), [])
    return (
        <HubDataContext.Provider value={moduleContext}>
            <HubFramework hubContent={moduleContent} module={moduleContext}/>
        </HubDataContext.Provider>
    )
}

export default Module;
